/**
 * SFX через синтез — без зовнішніх файлів. Кожен звук — короткий потік з
 * oscillator-ів і шумових буферів, який вмикається й одразу затухає.
 *
 * AudioContext створюється лазі при першому користувацькому жесті (бо
 * браузери блокують AudioContext до click/keydown).
 */
export const DEFAULT_AUDIO_PREFS = {
    enabled: true,
    volume: 0.5,
};
export class AudioBus {
    ctx = null;
    master = null;
    prefs;
    constructor(prefs = DEFAULT_AUDIO_PREFS) {
        this.prefs = { ...prefs };
    }
    /** Викликати з обробника користувацького жесту, інакше браузер заблокує. */
    ensureContext() {
        if (this.ctx)
            return;
        if (typeof AudioContext === 'undefined')
            return;
        this.ctx = new AudioContext();
        this.master = this.ctx.createGain();
        this.master.gain.value = this.prefs.enabled ? this.prefs.volume : 0;
        this.master.connect(this.ctx.destination);
    }
    setPrefs(prefs) {
        this.prefs = { ...prefs };
        if (this.master)
            this.master.gain.value = prefs.enabled ? prefs.volume : 0;
    }
    play(name) {
        if (!this.prefs.enabled)
            return;
        if (!this.ctx)
            this.ensureContext();
        if (!this.ctx || !this.master)
            return;
        switch (name) {
            case 'bomb_place':
                this.tick(80, 0.05);
                break;
            case 'explosion':
                this.boom();
                break;
            case 'pickup':
                this.ding(880, 0.15);
                break;
            case 'enemy_die':
                this.sweep(440, 110, 0.25);
                break;
            case 'player_die':
                this.sweep(220, 60, 0.6);
                break;
            case 'stage_clear':
                this.fanfare();
                break;
            case 'menu_select':
                this.tick(440, 0.04);
                break;
            case 'pause':
                this.tick(660, 0.06);
                break;
        }
    }
    // ───────────── synthesis primitives ─────────────
    tick(freq, dur) {
        const c = this.ctx, m = this.master, now = c.currentTime;
        const o = c.createOscillator();
        o.type = 'square';
        o.frequency.value = freq;
        const g = c.createGain();
        g.gain.setValueAtTime(0.4, now);
        g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
        o.connect(g).connect(m);
        o.start(now);
        o.stop(now + dur);
    }
    ding(freq, dur) {
        const c = this.ctx, m = this.master, now = c.currentTime;
        const o = c.createOscillator();
        o.type = 'triangle';
        o.frequency.value = freq;
        const o2 = c.createOscillator();
        o2.type = 'sine';
        o2.frequency.value = freq * 1.5;
        const g = c.createGain();
        g.gain.setValueAtTime(0.5, now);
        g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
        o.connect(g);
        o2.connect(g);
        g.connect(m);
        o.start(now);
        o2.start(now);
        o.stop(now + dur);
        o2.stop(now + dur);
    }
    sweep(fromHz, toHz, dur) {
        const c = this.ctx, m = this.master, now = c.currentTime;
        const o = c.createOscillator();
        o.type = 'sawtooth';
        o.frequency.setValueAtTime(fromHz, now);
        o.frequency.exponentialRampToValueAtTime(Math.max(40, toHz), now + dur);
        const g = c.createGain();
        g.gain.setValueAtTime(0.4, now);
        g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
        o.connect(g).connect(m);
        o.start(now);
        o.stop(now + dur);
    }
    boom() {
        const c = this.ctx, m = this.master, now = c.currentTime;
        const dur = 0.45;
        // шумовий буфер
        const buf = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
        const data = buf.getChannelData(0);
        for (let i = 0; i < data.length; i++) {
            const t = i / data.length;
            data[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 1.6);
        }
        const src = c.createBufferSource();
        src.buffer = buf;
        const lp = c.createBiquadFilter();
        lp.type = 'lowpass';
        lp.frequency.value = 700;
        const g = c.createGain();
        g.gain.value = 0.75;
        src.connect(lp).connect(g).connect(m);
        src.start(now);
        // басовий ХУ-у-у удар
        const o = c.createOscillator();
        o.type = 'sine';
        o.frequency.setValueAtTime(120, now);
        o.frequency.exponentialRampToValueAtTime(40, now + 0.35);
        const og = c.createGain();
        og.gain.setValueAtTime(0.5, now);
        og.gain.exponentialRampToValueAtTime(0.0001, now + 0.35);
        o.connect(og).connect(m);
        o.start(now);
        o.stop(now + 0.35);
    }
    fanfare() {
        const c = this.ctx, m = this.master, now = c.currentTime;
        const notes = [523, 659, 784, 1047]; // C5 E5 G5 C6
        notes.forEach((f, i) => {
            const o = c.createOscillator();
            o.type = 'triangle';
            o.frequency.value = f;
            const g = c.createGain();
            const t0 = now + i * 0.12;
            g.gain.setValueAtTime(0.0001, t0);
            g.gain.exponentialRampToValueAtTime(0.4, t0 + 0.02);
            g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.18);
            o.connect(g).connect(m);
            o.start(t0);
            o.stop(t0 + 0.20);
        });
    }
}
